import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GestoresService } from 'src/app/services/gestores.service';
import { __param } from 'tslib';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { RelatorioEmail } from 'src/app/models/relatorioEmail.model';
import { Eleicao } from 'src/app/models/eleicao.model';



@Component({
  selector: 'app-table-relatorio-email',
  templateUrl: './table-relatorio-email.component.html',
  styleUrls: ['./table-relatorio-email.component.css']
})
export class TableRelatorioEmailComponent implements OnInit {

  public emails: RelatorioEmail[] = [];
  public filteredEmails: RelatorioEmail[] = [];
  public token: any;
  public eleicao: Eleicao;
  paginaAtual: Number = 1;
  contador: Number = 30;

  @Input() eleicaoId: number;
  logo: any;
  offset: number;
  selectedDate: string = '';
  loginUsuarioFilter: string = '';
  destinatarioFilter: string = '';
  statusFilter: string = '';

  constructor(
    protected gestoresService: GestoresService,
    public spinner: NgxSpinnerService,
    protected router: Router,
    public utils: Utils
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    this.getEmails(this.eleicaoId, this.token);
    // var logoRaw = sessionStorage.getItem("logoeleicao");
    // this.logo = logoRaw
  }

  async getEmails(idEleicao: number, token: any) {
    this.gestoresService.getRelatorioEmails(idEleicao, token).then((emails: RelatorioEmail[]) => {
      this.emails = emails.sort(sortBy('createdAt'));
      this.filteredEmails = this.emails;
      this.spinner.hide();
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }

  separarDataHora(valor) {
    const dataHora = valor.eventos[0].hora.split("T");
    const separarHora = dataHora[1].split(".");
    const invertendoData = dataHora[0].split("-");
    const dataAno = invertendoData[0];
    const dataMes = invertendoData[1];
    const dataDia = invertendoData[2];
    const dataFormatada = dataDia + "/" + dataMes + "/" + dataAno

    return { data: dataFormatada, hora: separarHora[0] };
  }

  separarDataHoraEmail(valor) {
    const dataHora = valor.createdAt.split("T");
    const separarHora = dataHora[1].split(".");
    const invertendoData = dataHora[0].split("-");
    const dataAno = invertendoData[0];
    const dataMes = invertendoData[1];
    const dataDia = invertendoData[2];
    const dataFormatada = dataDia + "/" + dataMes + "/" + dataAno

    return { data: dataFormatada, hora: separarHora[0] };
  }

  async abrirRelatorioEmailDetalhado(email: any) {
    sessionStorage.setItem("idEleicao", String(email.eleicaoId))

    sessionStorage.setItem("logoeleicao", JSON.stringify(this.logo));

    sessionStorage.setItem("idEmail", String(email.id));

    this.router.navigate(['gestor/relatorio-email-detalhado']);
  }

  exportParaExcel() {
    let dadosResultado = this.filteredEmails;
    this.utils.exportRelatorioEmailParaExcel(dadosResultado);
  }

  applyDateFilter() {
    if (this.selectedDate !== '') {
      this.filteredEmails = this.filteredEmails.filter(email =>
        email.createdAt.includes(this.selectedDate)
      );
    }
  }

  applyLoginUsuarioFilter() {
    if (this.loginUsuarioFilter !== '') {
      const loginUsuarioFilters = this.loginUsuarioFilter.split(';').map(filter => filter.trim());
  
      this.filteredEmails = this.filteredEmails.filter(email =>
        loginUsuarioFilters.some(filter =>
          email.loginUsuario.toLowerCase().includes(filter.toLowerCase())
        )
      );
    }
  }
  
  applyDestinatarioFilter() {
    if (this.destinatarioFilter !== '') {
      const destinatarioFilters = this.destinatarioFilter.split(';').map(filter => filter.trim());
  
      this.filteredEmails = this.filteredEmails.filter(email =>
        destinatarioFilters.some(filter =>
          email.destinatario.toLowerCase().includes(filter.toLowerCase())
        )
      );
    }
  }

  applyStatusFilter() {
    if (this.statusFilter !== '') {
      this.filteredEmails = this.filteredEmails.filter(email =>
        email.eventos.length > 0 && email.eventos[0].status === this.statusFilter
      );
    }
  }

  applyFilters() {
    this.filteredEmails = this.emails;
    this.applyDateFilter();
    this.applyStatusFilter();
    this.applyLoginUsuarioFilter();
    this.applyDestinatarioFilter();
  }

  cleanFilters(){
    this.selectedDate = '';
    this.loginUsuarioFilter = '';
    this.destinatarioFilter = '';
     this.statusFilter = '';
    this.filteredEmails = this.emails;
  }


}
